import { AccountsAPI } from 'api'

export const getAccounts = async data => (
  AccountsAPI.get(`accounts/search`, {params: data})
)

export const newAccount = async account => (
  AccountsAPI.post(`accounts/create`, account)
)

export const deleteAccount = async id => (
  AccountsAPI.delete(`accounts/${id}`)
)

export const deleteAllAccounts = async () => (
  AccountsAPI.delete(`accounts/org`)
)

export const deleteAccounts = async ids => (
  AccountsAPI.post(`accounts/delete`, ids)
)

export const editAccount = async (account) => (
  AccountsAPI.patch(`accounts/update`, account)
)

export const getAccountProperties = async () => (
  AccountsAPI.get(`attrib`)
)
